export default __webpack_public_path__ + "static/media/amazon-white.6dd197f0.webp";